import { render } from "./MillsDetailsModal.vue?vue&type=template&id=767ca7ae&scoped=true"
import script from "./MillsDetailsModal.vue?vue&type=script&lang=js"
export * from "./MillsDetailsModal.vue?vue&type=script&lang=js"

import "./MillsDetailsModal.vue?vue&type=style&index=0&id=767ca7ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767ca7ae"]])

export default __exports__